<template lang="pug">
b-table.table-outline.mb-0(hover, outline, head-variant='default', :items='data', :fields='label', :small='small' fixed=true @row-clicked='editIntent')

  // SLOT intent numbers
  template(slot='intentId', scope='item')
    | {{item.value}}

  // SLOT Intent title
  template(slot='intentTitle', scope='item')
    | {{item.value}}

  // SLOT Intent Answers
  template(slot='intentAnswers', scope='item')
    div.row
      div.col-sm-9
        //Using v-bind to set id dyanmically to tally with the collapse button
        b-collapse(v-bind:id="'answerCollapse-' + item.index")
          span(v-html='item.value')
        span(v-if='!item.item.answerCollapseIs')
          | {{cutMessages(item.value)}}
      div.col-sm-3
        b-btn.float-left(v-b-toggle="`answerCollapse-${item.index}`", style='background-color:white;border-color:white;' @click='collapseAnswer(item)')
          i(class='fa fa-chevron-down' v-if='!item.item.answerCollapseIs')
          i(class='fa fa-chevron-up' v-if='item.item.answerCollapseIs')

  // SLOT Utterances
  // Showing number of Questions/Keywords that triggers the intents
  template(slot='noOfTrainings', scope='item')
    span.text-center
      | {{item.value}}

  // SLOT Answer Type
  // Showing the type of answer of the intent
  template(slot='answerType', scope='item')
    span.text-center
      | {{item.value}}

  template(slot='quickReplies', scope='item')
    div.row(v-if="item.value === 'None'")
      span.text-center
        | {{item.value}}
    div.row(v-for='value in item.value' v-else)
      span.text-center
        | {{ value }}

  // SLOT Number of Bubble
  // SHowing number of quick replies that the intents have
  template(slot='noOfBubble', scope='item')
    span.text-center
      | {{item.value}}

  // SLOT Details
  // showing details such as Keywords and Quick Replies
  template(slot='show_details', scope='row')
    b-button.mr-2(size='sm' @click.stop='row.toggleDetails')
      | {{row.detailsShowing ? 'Hide' : 'Show more'}}

  template(slot='row-details' scope='row')
    b-card
      div.row
        div.col-sm-6
          b-form-group(label='Questions / Triggering Bubble')
            b-form-checkbox(v-model='selectAllQuestions' aria-describedby='row.item.intentQuestions' aria-constrol='row.item.intentQuestions')
            b-form-checkbox-group(stacked v-model='selectedQuestions' name='Questions' :options='row.item.intentQuestions')
        div.col-sm-6
          b-form-group(label='Quick Reply Bubble')
            b-form-checkbox-group(stacked v-model='selectedQuickReplies' name='QuickReplies' :options='row.item.quickReplies')

  template(slot='actions' scope='item')
    div.row
      div.col-sm-6
        b-btn
          i(class="fa fa-trash" aria-hidden="true" @click='removeIntent(item)' @click.stop='')
            | &nbsp;Remove
</template>

<script>
import { parseMessage } from '@/filter'

export default {
  name: 'intent-table',
  data() {
    return {
      selectedQuestions: [],
      selectedQuickReplies: [],
    }
  },
  props: {
    sortBy: null,
    sortDesc: true,
    loading: true,
    small: false,
    data: {
      type: Array,
      default: () => [],
    },
    label: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    toggleIntentEditor(item) {
      const that = this
      // if aside div is shown but the item is not the same as the intent details displayed
      // then hide, update and show the aside div again.
      if (document.getElementsByClassName('aside-menu-hidden').length === 0 && item !== this.$store.state.editIntentDetails) {
        document.body.classList.toggle('aside-menu-hidden')
        this.$store.dispatch('setAsideStatus', false)
        this.$store.dispatch('setEditIntents', item)
        setTimeout(function() {
          if (document.getElementsByClassName('aside-menu-hidden').length !== 0) {
            document.body.classList.toggle('aside-menu-hidden')
            that.$store.dispatch('setAsideStatus', true)
          }
        }, 500)
      // if the aside div is shown and the item is the same as the intent details displayed
      // then hide the div
      } else if (document.getElementsByClassName('aside-menu-hidden').length === 0 && item === this.$store.state.editIntentDetails) {
        document.body.classList.toggle('aside-menu-hidden')
        this.$store.dispatch('setAsideStatus', false)
      } else {
      // if the aside div is hidden.
      // update the aside div with the clicked row of the intent table and show the aside div.
        document.body.classList.toggle('aside-menu-hidden')
        this.$store.dispatch('setEditIntents', item)
        this.$store.dispatch('setAsideStatus', true)
      }
    },
    // When the row is clicked, send the data to the intent editor page.
    editIntent(item) {
      this.$store.dispatch('setActionInIntentPage', 'edit Intent')
      this.toggleIntentEditor(item)
    },
    removeIntent(item) {
      this.$store.dispatch('setRemoveIntent', item.item)
    },
    cutMessages(message) {
      // Cut long answers
      return parseMessage(message, 100)
    },
    collapseAnswer(item) {
      // To check if the answer is collapsed or not
      if (!item.item.answerCollapseIs) {
        item.item.answerCollapseIs = true
      } else {
        item.item.answerCollapseIs = false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/IntentTable.vue?1cf5a920